import http from '@services/http';
import { Projects } from '@services/api/interfaces';

export const getExternalLink = (data: Projects.GetExternalLink.Request): Promise<Projects.GetExternalLink.Response> => {
  return http.patch(`/projects/${data.projectId}/get-external-link`, {});
};

export const completeProject = (data: Projects.CompleteExternalProject.Request): Promise<Projects.CompleteExternalProject.Response> => {
  return http.post(`/projects/${data.projectId}/external-complete`, data);
};